import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ActivateGuard = ({ children }) => {
    const { token } = useSelector((state) => state.authReducer);

    if (token) {
        return <Navigate to="/activate" replace />;
    }

    return children;
};

export default ActivateGuard;